import { createSlice } from "@reduxjs/toolkit";
import type { EventType } from "../../models/eventType";
import { getEventTypes } from "../thunks/eventTypeThunks";

export interface EventTypeState {
  eventTypesLoading: boolean;
  eventTypesError: string | null;
  eventTypes: EventType[];
}

const initialState: EventTypeState = {
  eventTypesLoading: false,
  eventTypesError: null,
  eventTypes: [],
};

const eventTypeSlice = createSlice({
  name: "eventType",
  initialState,
  reducers: {
    clearEventTypesError: (state) => {
      state.eventTypesError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEventTypes.pending, (state) => {
        state.eventTypesLoading = true;
        state.eventTypesError = null;
      })
      .addCase(getEventTypes.fulfilled, (state, action) => {
        state.eventTypesLoading = false;
        state.eventTypes = action.payload.eventTypes;
      })
      .addCase(getEventTypes.rejected, (state, action) => {
        state.eventTypesLoading = false;
        state.eventTypesError =
          action.payload || action.error.message || "Failed to fetch event types";
      });
  },
});

export const { clearEventTypesError } = eventTypeSlice.actions;
export default eventTypeSlice.reducer;
